module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABY0lEQVR4Xu2XYYvCQAxEE+5Pn+ChdyJ3P1rIUamgYrXITnbCjp9rmvcy2bZug/98cH6TACVgcANagcEDoENQK6AVGNyAVmDwAOgpoBXQCgxuQCvAGICI+DSzD3c/ovujS8AM/zuDb9ESGAV8mdnP1eShEmgERMRugnb374jYmtkhQwKFgBl+PwPvH0jYuPsf4jzoLuAO/sJ4LeGEgj8nDmF1bc0F+BsJa2u9e103AS/gJ55zCt4FW/u/LgJY4LusABN8ugA2+FQBjPBpAljhUwQww8MFsMNDBVSAhwmoAo8UEE/exFLe8Lq+CUbEkgAq+OwE0MFnCqCEhwlYu38M13X5GmQAv/QgAa2m8eTkb3WLmzru3mR4TYpMnUnA8rNfCUAYoFsBBGRGzWZnQEaziHtIAMJqpZpKQKVpIXpVAhBWK9VUAipNC9GrEoCwWqmmElBpWohelQCE1Uo1lYBK00L0+g9CDYZBh/9UwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/common/edit.png
// module id = AUgf
// module chunks = 15